export default function ({ store }) {
  store.commit('errors/setErrors', {})
}
